// Generated by CoffeeScript 1.9.3
var MarginRight, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = MarginRight = (function(superClass) {
  extend(MarginRight, superClass);

  function MarginRight() {
    return MarginRight.__super__.constructor.apply(this, arguments);
  }

  return MarginRight;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/MarginRight.js
// module id = 1767
// module chunks = 0